import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from '@core/services/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { ImageCroppedEvent } from 'ngx-image-cropper';

export interface ImageCropperModalData {
  image: Event;
}

@Component({
  templateUrl: './image-cropper-modal.component.html',
  styles: [
    `
      ::ng-deep .modal-title {
        border-bottom: 0 !important;
      }
    `
  ]
})
export class ImageCropperModalComponent implements OnInit {
  ButtonTypes = ButtonTypes;
  ButtonSize = ButtonSize;

  croppedImage: Blob;
  imageChangedEvent: Event;

  dialogRef: MatDialogRef<any> = inject(MatDialogRef);
  snackBar: SnackBarService = inject(SnackBarService);
  translate: TranslateService = inject(TranslateService);
  data: ImageCropperModalData = inject(MAT_DIALOG_DATA) as ImageCropperModalData;

  ngOnInit(): void {
    this.imageChangedEvent = this.data.image;
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.blob;
  }

  loadImageFailed(): void {
    this.snackBar.error(this.translate.instant('imageLoadError'));
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.dialogRef.close(this.croppedImage ?? false);
  }
}
